import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Tabs,
  Tab
} from '@mui/material';
import {
  LocationOn as LocationIcon,
  Tune as GeneralIcon,
  Payment as PaymentIcon,
  Notifications as NotificationIcon
} from '@mui/icons-material';
import ServiceAreas from './ServiceAreas';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => (
  <div role="tabpanel" hidden={value !== index}>
    {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
  </div>
);

const Settings: React.FC = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
          Settings
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Configure application settings and preferences
        </Typography>
      </Box>

      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab
            icon={<LocationIcon />}
            label="Service Areas"
            iconPosition="start"
          />
          <Tab
            icon={<GeneralIcon />}
            label="General"
            iconPosition="start"
            disabled
          />
          <Tab
            icon={<PaymentIcon />}
            label="Payments"
            iconPosition="start"
            disabled
          />
          <Tab
            icon={<NotificationIcon />}
            label="Notifications"
            iconPosition="start"
            disabled
          />
        </Tabs>
      </Paper>

      <TabPanel value={currentTab} index={0}>
        <ServiceAreas />
      </TabPanel>

      <TabPanel value={currentTab} index={1}>
        <Paper sx={{ p: 3 }}>
          <Typography>General settings coming soon...</Typography>
        </Paper>
      </TabPanel>

      <TabPanel value={currentTab} index={2}>
        <Paper sx={{ p: 3 }}>
          <Typography>Payment settings coming soon...</Typography>
        </Paper>
      </TabPanel>

      <TabPanel value={currentTab} index={3}>
        <Paper sx={{ p: 3 }}>
          <Typography>Notification settings coming soon...</Typography>
        </Paper>
      </TabPanel>
    </Box>
  );
};

export default Settings;
